<template>
  <div
    class="tools_div"
    v-if="
      $store.state.toLastKeyName == '对话中' ||
      $store.state.toLastKeyName == '疑似骚扰用户' ||
      $store.state.toLastKeyName == '浏览中'
    "
  >
    <!-- <el-switch v-model="value1" active-text="机器人托管" inactive-text="取消托管" 
		style="margin-left:10px" @change="switchChange"></el-switch> -->
    <el-switch
      v-model="value1"
      active-text="机器人托管"
      inactive-text="取消托管"
      style="margin-left: 10px"
      @change="switchChange"
    ></el-switch>
    <el-button
      class="sendBtn"
      type="primary"
      size="mini"
      @click="sendAction"
      :disabled="config.canOperate == false"
      >发送</el-button
    >
    <!-- <div class="icon_box">
      <div
        class="btn_div"
        v-if="$store.state.toLastKeyName == '会话中'"
        v-show="$store.state.authority.isTransfer"
      >
        <img
          class="btn_icon"
          src="../../../static/talks/t_interpret.png"
          @click="interpretAction(0)"
        />
        <div class="btn_title">转接</div>
      </div>
      <div
        class="end_div"
        v-if="
          $store.state.toLastKeyName == '会话中' ||
          $store.state.toLastKeyName == '我的同事'
        "
        @click="endAction(1)"
        v-show="$store.state.authority.isEndChat"
      >
        <img class="btn_icon" src="../../../static/talks/t_end.png" />
        <div class="btn_title">结束对话</div>
      </div>

      <div
        v-if="
          $store.state.toLastKeyName == '会话中' ||
          $store.state.toLastKeyName == '疑似骚扰用户'
        "
        v-show="$store.state.authority.isDisturb"
      >
        <div class="btn_div1" v-if="!isDisturb" @click="disturbAction(2)">
          <img class="btn_icon" src="../../../static/talks/t_disturb.png" />
          <div class="btn_title">勿扰</div>
        </div>
        <div class="btn_div1_select" v-else @click="disturbAction(2)">
          <img
            class="btn_icon"
            src="../../../static/talks/t_disturbselect.png"
          />
          <div class="btn_title_select">勿扰</div>
        </div>
      </div>

      <div
        v-if="$store.state.toLastKeyName == '会话中'"
        v-show="$store.state.authority.isDefriend"
      >
        <div class="btn_div2" v-if="!isDefriend" @click="defriendAction(3)">
          <img class="btn_icon" src="../../../static/talks/t_defriend.png" />
          <div class="btn_title">拉黑</div>
        </div>
        <div class="btn_div2_select" v-else @click="defriendAction(3)">
          <img
            class="btn_icon"
            src="../../../static/talks/t_defriendselect.png"
          />
          <div class="btn_title_select">拉黑</div>
        </div>
      </div>
      <div
        class="btn_div3"
        v-if="$store.state.toLastKeyName === '我的同事'"
        v-show="$store.state.authority.isTransferTa"
        @click="adapterAction(4)"
      >
        <img class="btn_icon" src="../../../static/talks/t_adapter.png" />
        <div class="btn_title">转接Ta</div>
   
      </div>
    </div> -->
  </div>
</template>

<script>
export default {
  name: "bottomTools",

  props: {
    // user: {},
    switchVal: {
      type: Boolean,
      default: false,
    },
    config: {
      type: Object,
      default: () => ({
        name: "",
        ipdress: "",
        number: "4",
        tags: [],
        mark: "",
        itype: "0", //0-聊天界面引用  1-历史消息界面引用
        canOperate: Boolean, //界面元素是否可操作，false为不可，true为可以
      }),
      required: true,
    }
  },

  data() {
    return {
      value1: false,
      isDefriend: false,
      isDisturb: false,
      userInfo: {},
      isTranster: false,
      isSwitch: false,
    };
  },

  created() {
    console.log(
      "bottomTools.vue created value1 = ",
      this.value1,
      this.switchVal
    );
    this.value1 = this.switchVal;
  },
  watch: {
    switchVal() {
      this.value1 = this.switchVal;
    },
  },

  mounted() {
    console.log("bottomTools mounted keyname = ", this.$store.state.keyName);
    console.log(
      "bottomTools mounted tokeyname = ",
      this.$store.state.toLastKeyName
    );
    console.log(
      "bottomTools.vue mounted  selectedClient",
      this.$store.state.selectedClient
    );
  },

  // watch: {
  //   // value1(newValue1, oldValue1) {
  //   //   var selected =
  //   //     this.$store.state.selectedClient ||
  //   //     this.$store.state.college.nowSelectClient;
  //   //   console.log("bottomTools.vue watch value1", newValue1, oldValue1);
  //   //   if (!selected.hasLeaved) {
  //   //     if (newValue1) {
  //   //       // 机器人托管
  //   //       this.trustputRequest(selected.sid);
  //   //       this.isSwitch = false;
  //   //     } else {
  //   //       //取消托管
  //   //       if (this.isSwitch) {
  //   //         this.cancelTrustRequest(selected.sid);
  //   //         this.isSwitch = false;
  //   //       }
  //   //     }
  //   //   }
  //   // },
  //   // selectedClient: {
  //   //   handler(newValue, oldValue) {
  //   //     console.log(
  //   //       "bottomTools.vue watch  selectedClient",
  //   //       newValue,
  //   //       oldValue
  //   //     );
  //   //     if (newValue && oldValue && newValue.sid !== oldValue.sid) {
  //   //       // 机器人托管
  //   //       this.trustputRequest(selected.sid);
  //   //       this.isSwitch = false;
  //   //     } else {
  //   //       //取消托管
  //   //       if (this.isSwitch) {
  //   //         this.cancelTrustRequest(selected.sid);
  //   //         this.isSwitch = false;
  //   //       }
  //   //     }
  //   //   },
  //   //   deep: true,
  //   // },
  // },

  methods: {
    sendAction() {
      console.log("tools sendAction function");
      if (this.$store.state.colleageAngle) {
        this.$store.state.college.nowSelectClient.inputValue = "";
      } else {
        this.$store.state.selectedClient.inputValue = "";
      }
      this.$emit("clickSend");
    },
    endSccess(data) {
      console.log("bottomTools endSccess data = ", data);
      const jsonData = JSON.parse(data.data);
      console.log("bottomTools endSccess jsonData = ", jsonData);
      if (jsonData.messageType === "6") {
        this.$message({
          message: "会话已结束",
          type: "success",
        });
      }
    },

    switchChange(val) {
      console.log("bottomTools switchChange val = ", val);
      this.isSwitch = val;
      const sid = this.$store.state.selectedClient.sid;
      if (val) {
        this.trustputRequest(sid);
      } else {
        this.cancelTrustRequest(sid);
      }
    },

    async trustputRequest(sid) {
      const response = await this.util.postRequest({
        url: "/manager/session/trusteeship",
        method: "POST",
        data: {
          sid: sid,
        },
      });
      console.log("bottomTools trustputRequest response = ", response);
      if (response.resultCode === "10000") {
        this.$emit("isTrust", true);
      } else {
        this.$message.error(response.desc);
      }
    },

    async cancelTrustRequest(sid) {
      const response = await this.util.postRequest({
        url: "/manager/session/cancel/trusteeship",
        method: "POST",
        data: {
          sid: sid,
        },
      });
      console.log("bottomTools trustputRequest response = ", response);
      if (response.resultCode === "10000") {
        this.$emit("isTrust", false);
      } else {
        this.$message.error(response.desc);
      }
    },

    endError(data) {
      console.log("bottomTools endError data = ", data);
    },

    // interpretAction(index) {
    //   console.log("bottomTools interpretAction index = ", index);
    //   this.isTranster = true;
    //   this.$emit("interpretAction", true);
    // },

    // endAction(index) {
    //   console.log("bottomTools endAction index = ", index);
    //   console.log("bottomTools endAction userInfo = ", this.userInfo);

    //   this.$confirm(
    //     "你确认要设置结束对话吗？",
    //     "确认结束后将不再收到访客发送的消息",
    //     {
    //       confirmButtonText: "确定",
    //       cancelButtonText: "取消",
    //       type: "warning",
    //       showClose: false,
    //     }
    //   )
    //     .then(() => {
    //       this.$emit("endChat", true);
    //     })
    //     .catch(() => {});
    // },

    // disturbAction(index) {
    //   console.log("bottomTools disturbAction index = ", index);

    //   if (this.isDisturb === false) {
    //     this.$confirm(
    //       "你确认要设置勿扰操作吗？",
    //       "设置为勿扰模式后，针对该用户，系统将接收不到新消息提醒，会话保留",
    //       {
    //         confirmButtonText: "确定",
    //         cancelButtonText: "取消",
    //         type: "warning",
    //         showClose: false,
    //       }
    //     )
    //       .then(() => {
    //         this.setDisturbRequest();
    //       })
    //       .catch(() => {});
    //   } else {
    //     this.$confirm(
    //       "你确认要取消勿扰设置吗？",
    //       "取消勿扰设置后，将继续收到此用户发送的消息提醒",
    //       {
    //         confirmButtonText: "确定",
    //         cancelButtonText: "取消",
    //         type: "warning",
    //         showClose: false,
    //       }
    //     )
    //       .then(() => {
    //         this.cancelDisturbRequest();
    //       })
    //       .catch(() => {});
    //   }
    // },

    // defriendAction(index) {
    //   console.log("bottomTools defriendAction index = ", index);

    //   if (this.isDefriend === false) {
    //     this.$confirm(
    //       "你确认要设置拉黑操作吗？",
    //       "确认要拉黑访客吗？加入黑名单后，系统将收不到该访客的任何信息，直到从黑名单列表中解禁",
    //       {
    //         confirmButtonText: "确定",
    //         cancelButtonText: "取消",
    //         type: "warning",
    //         showClose: false,
    //       }
    //     )
    //       .then(() => {
    //         this.setBlackRequest();
    //       })
    //       .catch(() => {});
    //   } else {
    //     this.isDefriend = false;
    //   }
    // },

    // async setBlackRequest() {
    //   const selected = this.$store.state.selectedClient;
    //   var api = "/manager/blacklist/add";
    //   const response = await this.util.postRequest({
    //     url: api,
    //     method: "POST",
    //     data: {
    //       conversationId: selected.sid,
    //       blackUserId: selected.cid,
    //       blackUserName: selected.nickname,
    //     },
    //   });
    //   console.log("index setBlackRequest response = ", response);
    //   if (response.resultCode === "10000") {
    //     this.isDefriend = true;
    //   }

    //   this.$store.dispatch("removeFromTalk", selected);
    //   this.$store.state.selectedClient = null;
    // },

    // adapterAction(index) {
    //   console.log("bottomTools adapterAction index = ", index);
    //   // this.$confirm('你确认要接管吗？', '接管之后，会话将从对方的聊天列表中移除', {
    //   // 	confirmButtonText: '确定',
    //   // 	cancelButtonText: '取消',
    //   // 	type: 'warning',
    //   // 	showClose:false
    //   // }).then(() => {

    //   // 	this.setAdapterRequest()

    //   // }).catch(() => {

    //   // });
    //   this.isTranster = true;
    //   this.$emit("interpretAction", false);
    // },

    // async cancelDisturbRequest() {
    //   const selected = this.$store.state.selectedClient;
    //   const account = this.util.getLocalAccount();

    //   var api = "/manager/session/del";
    //   const response = await this.util.postRequest({
    //     url: api,
    //     method: "POST",
    //     data: {
    //       userId: account.id,
    //       customerId: selected.cid,
    //       sid: selected.sid,
    //     },
    //   });
    //   console.log("bottomTools cancelDisturbRequest response = ", response);
    //   if (response.resultCode === "10000") {
    //     this.isDisturb = !this.isDisturb;
    //     if (this.isDisturb === false) {
    //       //取消勿扰
    //       this.$store.commit("spliceTroubleObj", selected);
    //       if (response.data === 1) {
    //         this.$store.commit("addTalkObj", selected);
    //       } else {
    //         this.$store.commit("addLeaveObj", selected);
    //       }
    //     }
    //   } else {
    //     this.$message.error(response.desc);
    //   }
    // },

    // async setDisturbRequest() {
    //   const selected = this.$store.state.selectedClient;
    //   const account = this.util.getLocalAccount();

    //   var api = "/manager/session/addOrEdit";
    //   const response = await this.util.postRequest({
    //     url: api,
    //     method: "POST",
    //     data: {
    //       userId: account.id,
    //       customerId: selected.cid,
    //       sid: selected.sid,
    //     },
    //   });
    //   console.log("bottomTools setDisturbRequest response = ", response);
    //   if (response.resultCode === "10000") {
    //     this.isDisturb = !this.isDisturb;
    //     if (this.isDisturb === true) {
    //       //设置勿扰
    //       if (this.$store.state.selectedKey === 1) {
    //         this.$store.commit("spliceTalkObj", selected);
    //       } else if (this.$store.state.selectedKey === 2) {
    //         this.$store.commit("spliceBrowerObj", selected);
    //       } else if (this.$store.state.selectedKey === 3) {
    //         this.$store.commit("spliceLeaveObj", selected);
    //       }

    //       this.$store.commit("addTroubleObj", selected);
    //     }
    //   }
    // },

    async setAdapterRequest() {
      const selected = this.$store.state.college.nowSelectClient;
      const account = this.util.getLocalAccount();
      // const parent = this.$store.state.parentNode
      console.log("selected = ", selected);
      // console.log('parent = ', parent)

      var api = "/manager/session/takeover";
      const response = await this.util.postRequest({
        url: api,
        method: "POST",
        data: {
          csid: account.id,
          f_csid: selected.csid,
          sid: selected.sid,
        },
      });
      console.log("bottomTools setAdapterRequest response = ", response);
      if (response.resultCode === "10000") {
        //添加到我的会话列表中（会收到type11消息，所以无需手动操作会话列表）
        //从我的同事会话列表中移除
        // this.$store.commit('addTalkObj', selected)
        this.$emit("setAdapter", true);
      } else {
        this.$message.error(response.desc);
      }
    },
  },
};
</script>

<style>
.tools_div {
  background: #e2e8f0;
  width: 100%;
  height: 42px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  /* position: fixed; */
  /* margin-bottom: 0rem; */
}

.icon_box {
  /* width: 300px; */
  height: 2.375rem;
  /* background-color: antiquewhite; */
  display: flex;
  justify-content: flex-end;
}

.btn_div,
.end_div,
.btn_div1,
.btn_div2,
.btn_div3,
.btn_div1_select,
.btn_div2_select,
.btn_div3_select {
  width: 60px;
  height: 38px;
  /* background: grey; */
  margin-left: 8px;
  margin-right: 6px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
}

.end_div {
  width: 50px;
}

.btn_div:hover .btn_title,
.end_div:hover .btn_title,
.btn_div1:hover .btn_title,
.btn_div2:hover .btn_title,
.btn_div3:hover .btn_title {
  color: #5a9cf8;
}

.end_div:hover .btn_icon {
  content: url("../../../static/talks/t_endhover.png");
}

.btn_div:hover .btn_icon {
  content: url("../../../static/talks/t_interprethover.png");
}

.btn_div1:hover .btn_icon {
  content: url("../../../static/talks/t_disturbhover.png");
}

.btn_div2:hover .btn_icon {
  content: url("../../../static/talks/t_defriendhover.png");
}

.btn_div3:hover .btn_icon {
  content: url("../../../static/talks/t_adapterhover.png");
}

.btn_title,
.btn_title_select {
  width: 100%;
  height: 15px;
  font-size: 9px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #444444;
  /* background-color: orange; */
  display: flex;
  justify-content: center;
}

.btn_title_select {
  color: red;
}

.btn_icon {
  width: 18px;
  height: 16px;
  /* margin-bottom: 5px; */
  margin-top: 2px;
}
</style>
<style lang="scss" scoped>
.sendBtn {
  margin-right: 12px;
  margin-left: 8px;
  @include change_size($font_size_normal);
}
</style>
